export default "__VITE_ASSET__BJyd6t$3__"